import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule, Routes } from '@angular/router';

import { HomeComponent } from '../paginas/home/home.component'
import { ConsultarDadosComponent } from '../paginas/consultar-dados/consultar-dados.component'
import { GerenciarRelatoriosComponent } from '../paginas/relatorios/gerenciar-relatorios/gerenciar-relatorios.component'
import { EditDelRelatoriosComponent } from '../paginas/relatorios/edit-del-relatorios/edit-del-relatorios.component'
import { GerenciarUsuariosComponent } from '../paginas/administracao/gerenciar-usuarios/gerenciar-usuarios.component'
//import { GerenciarGruposComponent } from '../paginas/administracao/gerenciar-grupos/gerenciar-grupos.component'
import { GerenciarConexoesComponent } from '../paginas/relatorios/gerenciar-conexoes/gerenciar-conexoes.component';
import { AuditoriaComponent } from '../paginas/administracao/auditoria/auditoria.component';

const routes: Routes = [
  { path: '', redirectTo: '/home', pathMatch: 'full' },
  { path: 'home',  component: HomeComponent },
  { path: 'consultardados',  component: ConsultarDadosComponent },
  { path: 'novorelatorio', component: GerenciarRelatoriosComponent },
  { path: 'editarrelatorio', component: GerenciarRelatoriosComponent },
  { path: 'gerenciarrelatorios', component: EditDelRelatoriosComponent },
  { path: 'gerenciarusuarios', component: GerenciarUsuariosComponent },
  // { path: 'gerenciargrupos', component: GerenciarGruposComponent },
  { path: 'gerenciarconexoes', component: GerenciarConexoesComponent },
  { path: 'auditoria', component: AuditoriaComponent}
];


@NgModule({
  imports: [ RouterModule.forRoot(routes)],
  exports: [ RouterModule ],
  declarations: []
})
export class AppRoutingModule { }



// WEBPACK FOOTER //
// C:/Users/ewerton.w.da.silva/Documents/Visual Studio 2017/Projects/SCL_Valia/SCL_Valia/src/app/app-routing/app-routing.module.ts